import {Button, ButtonProps, useListContext, useNotify} from "react-admin";
import {client} from "../../dataProvider";
import {useState} from "react";
import {CircularProgress} from "@material-ui/core";
import PublishIcon from "@material-ui/icons/Print";

export const PrintMultiRouteZipButton = (props: ButtonProps) => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const { selectedIds, refetch } = useListContext();
  const handleSubmit = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    client(`routes/set_print_multi_route_zip_with_qr_post`, {
      method: "POST",
      data: { ids: selectedIds },
    })
      .then(() => {
        refetch();
        notify("Fatto", "success");
      })
      .catch(() => {
        notify("ra.message.error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Button
      {...props}
      disabled={loading || selectedIds.length <= 0}
      label="Stampa giri A5"
      onClick={handleSubmit}
    >
      {loading ? <CircularProgress size={18} thickness={2} /> : <PublishIcon />}
    </Button>
  );
};
